/**
 * 限时配置模块
 * 用于管理项目中所有限时活动的配置和判断逻辑
 */

/**
 * 判断当前时间是否在指定的时间范围内
 * @param startTime 开始时间（可选）
 * @param endTime 结束时间（可选）
 * @returns 是否在有效期内
 */
export function isValidDate(startTime?: Date, endTime?: Date): boolean {
  const now = new Date();

  // 如果有开始时间，检查是否已经开始
  if (startTime && now < startTime) {
    return false;
  }

  // 如果有结束时间，检查是否已经结束
  if (endTime && now > endTime) {
    return false;
  }

  return true;
}

/**
 * 限时配置常量
 * 用于配置各种限时活动的时间范围
 */
export const LIMITED_TIME_CONFIG = {
  // 详情页限时图片配置（截止到2025年12月31日23:59:59）
  RESULT_PAGE_IMAGE: {
    endTime: new Date('2025-12-31 23:59:59'),
  },
  // 可以在这里添加更多限时配置
  // 例如：
  // SPRING_FESTIVAL_BANNER: {
  //   startTime: new Date('2025-01-20 00:00:00'),
  //   endTime: new Date('2025-02-10 23:59:59'),
  // },
};

/**
 * 判断是否在限时配置的有效期内
 * @param config 限时配置对象，包含 startTime 和/或 endTime
 * @returns 是否在有效期内
 */
export function isInLimitedTime(config: { startTime?: Date; endTime?: Date }): boolean {
  const { startTime, endTime } = config;
  return isValidDate(startTime, endTime);
}

/**
 * 是否展示大埔援助内容
 */
export function isShowDapuHelp() {
  return isInLimitedTime(LIMITED_TIME_CONFIG.RESULT_PAGE_IMAGE);
}
